module.exports = __webpack_public_path__ + "static/media/four_monkeys.6754e6c9.gif";